export default __webpack_public_path__ + "static/difiLogoIcon-9ebaad576525aedba51661b1ba134614.png";